import useApi from "hooks/use_api"

const useTransactions = (id, data = {}) => {
  const sharedFields = [
    "humanized_amount",
    "created_at_for_display",
    "id",
    "note",
    "short_description",
    "show_path"
  ]

  const defaultData = {
    fields: {
      Payment: sharedFields.join(),
      Refund: [...sharedFields, "instrument"].join()
    }
  }

  const { loading, response: transactions, errors } = useApi({
    path: `registrations/${id}/transactions`,
    data: { ...defaultData, ...data }
  })

  return { loading, transactions, errors }
}

export default useTransactions
